import { Link } from 'react-router-dom';
import { ButtonPest } from '../../../utils/Button';

function ReportCategoryButton({ summaryPath, detailsPath, applicationWisePath, customerWisePath }) {
    return (
        <div className="flex items-center gap-x-2">
            <Link to={summaryPath} target="_blank">
                <ButtonPest title="Summary" onClick={null} className="md:py-2 md:px-5 md:text-lg" />
            </Link>
            <Link to={detailsPath} target="_blank">
                <ButtonPest title="Details" onClick={null} className="md:py-2 md:px-5 md:text-lg" />
            </Link>
            <Link to={applicationWisePath} target="_blank">
                <ButtonPest
                    title="Application Wise"
                    onClick={null}
                    className="md:py-2 md:px-5 md:text-lg"
                />
            </Link>
            <Link to={customerWisePath} target="_blank">
                <ButtonPest
                    title="Customer Wise"
                    onClick={null}
                    className="md:py-2 md:px-5 md:text-lg"
                />
            </Link>
        </div>
    );
}

export default ReportCategoryButton;
